import React, { FC } from 'react';
import Box from '@material-ui/core/Box';
import { startPostMessageService } from '../lib/postMessageService';
import { postGTMAttributes } from '../lib/gtmService';
import { globalHistory } from '@reach/router';
import { NotificationsContextProvider } from '../providers/NotificationsProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import TransitionProvider from '../providers/TransitionProvider';
import PromotionProvider from '../providers/PromotionProvider';
import { ThemeProvider } from '../providers/ThemeProvider';
import TranslationLoader from '../components/translation-loader/TranslationLoader';
import ErrorBoundary from '../components/error-boundary/ErrorBoundary';
import Backdrop from '../components/backdrop';
import PathProvider from '../providers/PathProvider';
import InvoicePaymentSessionTimeout from '../components/invoice-payment-portal/invoicePaymentSessionTimeout';
import { Navigation } from '../components/invoice-payment-portal/navigation';
import Notifications from '../components/notifications';

startPostMessageService();

globalHistory.listen(({ location }) => {
  postGTMAttributes(location.pathname);
});

interface Props {
  readonly element: any;
  readonly props: Readonly<{
    pageContext: Record<string, any>;
    pageResources: Record<string, any>;
    location: Record<string, any>;
  }>;
}

const wrapPageElement: FC<Props> = ({
  element,
  props: { pageContext, pageResources, location },
}) => {
  const renderPageComponents = () => (
    <Box
      id={'full-height-shim'}
      display={'flex'}
      flexDirection={'column'}
      minHeight="100vh"
    >
      <>
        <Box id="pge-header">
          <Navigation />
        </Box>
      </>
      <Box id="global-notifications-banner">
        <Notifications />
      </Box>
      <Box flexGrow={1}>{element}</Box>
      <Backdrop />
    </Box>
  );

  return (
    <ThemeProvider>
      <TransitionProvider>
        <NotificationsContextProvider>
          <PromotionProvider context={{ ...pageContext, ...pageResources }}>
            <PathProvider context={pageContext.slugPathMap}>
              <CssBaseline />
              <TranslationLoader />
              <ErrorBoundary>
                <InvoicePaymentSessionTimeout />

                {renderPageComponents()}
              </ErrorBoundary>
            </PathProvider>
          </PromotionProvider>
        </NotificationsContextProvider>
      </TransitionProvider>
    </ThemeProvider>
  );
};

export default wrapPageElement;
